import {
  GRID_PADDING,
  MIN_CELL_SIZE,
  WELL_GAP,
  GridConfig,
  DEFAULT_GRID_ROWS,
  DEFAULT_GRID_COLUMNS,
} from './constants';
import { getWellAndCanvasLabels } from '../DRCIPWUtil';

export const getCanvasLabels = (cols: number, rows: number) => {
  return getWellAndCanvasLabels(cols, rows).canvasLabels;
};

// Calculate grid configuration based on container size
export const calculateGridConfig = (
  containerWidth: number,
  containerHeight: number,
  rows: number,
  cols: number,
): GridConfig | null => {
  if (containerWidth === 0 || containerHeight === 0) {
    return null;
  }

  const totalCols = DEFAULT_GRID_COLUMNS + 1;
  const totalRows = DEFAULT_GRID_ROWS + 1;
  const availableWidth = containerWidth - GRID_PADDING;
  const availableHeight = containerHeight - GRID_PADDING;
  const cellWidth = availableWidth / totalCols;
  const cellHeight = availableHeight / totalRows;
  const cellSize = Math.max(MIN_CELL_SIZE, Math.min(cellWidth, cellHeight));

  const labelAreaWidth = cellSize;
  const labelAreaHeight = cellSize;

  // Well size is cell size minus gap
  const wellSize = cellSize - WELL_GAP;

  // Visible viewport is fixed to default grid size
  const viewportWidth =
    labelAreaWidth + GRID_PADDING / 2 + DEFAULT_GRID_COLUMNS * cellSize;
  const viewportHeight =
    labelAreaHeight + GRID_PADDING / 2 + DEFAULT_GRID_ROWS * cellSize;

  // Scrollable content uses actual plate size
  const contentWidth = GRID_PADDING / 2 + cols * cellSize;
  const contentHeight = GRID_PADDING / 2 + rows * cellSize;

  return {
    cellSize,
    wellSize,
    gap: WELL_GAP,
    startX: labelAreaWidth,
    startY: labelAreaHeight,
    labelAreaWidth,
    labelAreaHeight,
    viewportWidth,
    viewportHeight,
    contentWidth,
    contentHeight,
  };
};
